import React from "react";
import moment from "moment";
import { MILESTONES } from "./AnnualOkrHelpers";

const STEP_DATE_FORMAT = "Do MMM, YY";

// The eight-step milestone timeline inside each client row's accordion body.
// Deliberately the same component as `ExecutionBlueprintSteps` with a different
// list — same markup, same classes, same date format — so a coach moving
// between the two dashboards is reading one design, not two.
//
// done/current are driven by `filled` (the row's `stage_index`); `timestamps`
// is consulted only for DISPLAY (a step's real label and date), looked up by
// milestone `key` rather than by array position.
//
// ⚠️ KEYED LOOKUP, NOT POSITIONAL, and not "render the array directly" either.
// An earlier version mapped `timestamps[]` straight through, which made the
// timeline's length depend on the payload: a row whose array arrived short
// rendered a shorter timeline, so rows in the same column stopped lining up.
// Worse, a positional read would mis-LABEL steps rather than merely dropping
// them — silently attaching one milestone's date to another's name. Iterating
// the fixed list and looking each key up is right whether the server sends all
// eight entries or only the ones reached so far.
const AnnualOkrSteps = ({ filled = 0, timestamps = [] }) => {
  const timestampByKey = new Map(
    (timestamps || []).map((timestamp) => [timestamp.key, timestamp]),
  );

  return (
    <div className="aok-steps">
      {MILESTONES.map(({ key, label: fallbackLabel }, index) => {
        const stepNumber = index + 1;
        const isDone = stepNumber <= filled;
        const isCurrent = stepNumber === filled;
        const timestamp = timestampByKey.get(key);

        return (
          <div
            key={key}
            className={`aok-step-row ${isDone ? "done" : ""} ${
              isCurrent ? "current" : ""
            }`}
          >
            <div className="aok-step-number">Step {stepNumber}</div>
            <div className="aok-step-icon">
              {isDone ? (
                <img src="/assets/images/true-sucess.svg" alt="" />
              ) : (
                "–"
              )}
            </div>
            <div className="aok-step-label">
              {/* Ours, not `timestamp.label` — see MILESTONES. */}
              {fallbackLabel}
            </div>
            <div className="aok-step-date">
              {/* §6.1 calls the field `at`, not `date`. A dash rather than an
                  empty cell for a step not yet reached — matching EXW, and so
                  the column reads as a column. */}
              {isDone && timestamp?.at
                ? moment(timestamp.at).format(STEP_DATE_FORMAT)
                : "-"}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AnnualOkrSteps;
